import * as actions from "./actionTypes";

import { MessageAction } from "./actions";

import { MessageDetails } from "./models";

export function messages(state: MessageDetails[] = [], action: MessageAction): MessageDetails[] {
    switch (action.type) {
        case actions.CREATE_CASE_MESSAGE:
            return [...state, action.payload];
        case actions.REPLY_CASE_MESSAGE:
            const messagingState = [...state];

            messagingState.map(m => {
                if (m.subject === action.payload.subject)
                {
                    m.messages = m.messages.concat(action.payload.messages);
                }
            });

            return messagingState;
        case actions.GET_CASE_CONVERSATION_MESSAGES:
        case actions.GET_CASE_MESSAGES:
            return action.payload;
        default:
            return state;
    }
}
